module.exports = __webpack_public_path__ + "36c4994d9316210e9e6f952e9ddfbb3b.svg";